export const vms_gen4 = [
  { name: "VM01 Zerschneider", location: "Route 201 – von Sinnoh-Luftschiff-Kapitän" },
  { name: "VM02 Fliegen", location: "Route 206 – Meteor-Fall" },
  { name: "VM03 Surfer", location: "Route 210 – Haus nahe See" },
  { name: "VM04 Stärke", location: "Straßburg City – Haus im Norden" },
  { name: "VM05 Blitz", location: "Route 212 – Haus am Wasser" },
  { name: "VM06 Lehmbrühe", location: "Phönix-Flugstraße – über Drachenbändiger" },
  { name: "VM07 Gebirge", location: "Route 223 – oberhalb der Sinnoh-Liga" }
];